import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { isDefined } from 'utils/functional';

import { getCmsBlockHasBackground } from './getCmsBlockHasBackground';
import { getIsContentFullWidthLayout } from './getIsContentFullWidthLayout';
import { getLastNonScollTrackingContentBlock } from './getLastNonScollTrackingContentBlock';

type Props = {
  content: CmsApiPage;
};

export function getHideFooterDivider({ content }: Props) {
  const lastBlock = getLastNonScollTrackingContentBlock({ content });
  const fullWidthLayout = getIsContentFullWidthLayout({ content });

  return (
    isDefined(lastBlock) &&
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    ((lastBlock.type === 'SPLIT_CONTENT' &&
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      lastBlock.data.appearance === 'FULL_WIDTH' &&
      fullWidthLayout) ||
      [
        'GRAD_CTA_HERO',
        'CTA_HERO',
        'STICKY_HEADER_LINKS_GRAD',
        'STICKY_HEADER_LINKS',
        'SCROLL_TRACKING',
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      ].includes(lastBlock.type) ||
      getCmsBlockHasBackground({
        // @ts-expect-error TS(2322): Type 'undefined' is not assignable to type 'CmsApi... Remove this comment to see the full error message
        block: lastBlock,
        fullWidthLayout,
      }))
  );
}
